import PropTypes from 'prop-types';

const discounts = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    criteria: PropTypes.number,
    name: PropTypes.string,
    formattedValue: PropTypes.string,
    base_amount: PropTypes.number
  })
);

export default PropTypes.shape({
  name: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      productId: PropTypes.string,
      dimension_name_1: PropTypes.string,
      dimension_1: PropTypes.string,
      dimension_name_2: PropTypes.string,
      dimension_2: PropTypes.string,
      dimension_name_3: PropTypes.string,
      dimension_3: PropTypes.string,
      retail_price: PropTypes.number,
      original_price: PropTypes.number,
      track_quantity: PropTypes.bool,
      quantity: PropTypes.number,
      discounts: discounts
    })
  ),
  specs: PropTypes.shape({}),
  discounts: discounts
});



// WEBPACK FOOTER //
// ./src/model/Types/itemOfProductModal.js